import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import messages from '../../utils/translationMessages';
import './styles.css';

class DefaultImage extends PureComponent {

  render () {
    const { size, withText, intl: { formatMessage: t } } = this.props;
    return (
      <div className="default-image-wrapper">
        <div className="default-image-centered-container">
          <div className="default-image-icon" style={{height: `${size}px`, width: `${size}px`}}></div>
          { withText && <div className="default-image-text">{t(messages.defaultNotFoundImage)}</div> }
        </div>
      </div>
    );
  }
}

DefaultImage.defaultProps = {
  size: '130',
  withText: true
};

DefaultImage.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  /** The size in pizels of the icon */
  size: PropTypes.string,
  withText: PropTypes.bool
};

export default injectIntl(DefaultImage);
